import React from "react";
import MeasurementsDashboard from "../measurements/MeasurementsDashboard";

const ClientDashboard = () => {
  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <MeasurementsDashboard/>
      </div>
    </div>
  )
};

export default ClientDashboard;